import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "insights",
    object: "insight",
    header: [
      { text: "ID", value: "id" },
      { text: "Question", value: "question" },
      { text: "Answer", value: "answer" },
      { text: "Actions", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions,
    getUsersOfStores({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        let filter = {
          ...options,
          search: ""
        };
        axios
          .get(config.api_url + "users_of_stores", { params: filter })
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
    getCostTotals({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        let filter = {
          ...options,
          search: ""
        };
        axios
          .get(config.api_url + "total_costs", { params: filter })
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    }
  },
  getters: {
    ...genericStore.getters
  }
};
